import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Section, SectionHeadline } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { ViewOpeningsButton } from "@faire/retailer-visitor-shared/views/careers/ViewOpeningsButton";
import { Spacer } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var JobOpeningsSection = function() {
    return /*#__PURE__*/ _jsxs(Section, {
        $withHorizontalPadding: true,
        $withVerticalPadding: true,
        $backgroundColor: Decorative.shade.yellow,
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(SectionHeadline, {
                color: Core.text.inverse,
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "pK/AQV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Join us and help create a bright future for independent retailers & brands"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    desktopAndAbove: "5x",
                    mobileAndAbove: "4x"
                }
            }),
            /*#__PURE__*/ _jsx(ViewOpeningsButton, {
                isSecondary: true,
                buttonText: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "JKWqkn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "All Job Openings"
                        }
                    ]
                })
            })
        ]
    });
};
